import { CollapseProps } from "antd";
import { CustomCollapse } from "../../../../../../common/components/Collapse/Collapse";
import { useContext, useEffect, useState } from "react";
import { OperationContext } from "../../CreateOperation";
import { TableContent } from "../tableContent/TableContent";
import { useSearchParams } from "react-router";
import { ExportPdf } from "../../../../../../common/components/Export/ExportPdf";
import { CustomEmpty } from "../../../../../../common/components/Empty/CustomEmpty";

export const DebarkmentOvertime = () => {
  const { initialValue, filter } = useContext(OperationContext);

  const [teams, setTeams] = useState<CollapseProps["items"]>([]);

  const [searchParams] = useSearchParams();
  const movement = searchParams.get("movment");

  useEffect(() => {
    setTeams(() =>
      initialValue?.teamsArray?.map((item: any) => ({
        ...item,
        key: item?.id,
        label: item?.name,
        children: (
          <TableContent
            item={{
              key: item?.id,
              label: item?.name,
            }}
          />
        ),
      }))
    );
  }, [initialValue]);

  return (
    <>
      {teams?.length ? (
        <>
          <div className="w-full d-flex justify-content-end">
            <ExportPdf
              uri={`/api/extra-works/${movement}/pdf`}
              params={{
                dates: [filter.teamsCreatedAt],
              }}
            />
          </div>
          <div className="mt-4">
            <CustomCollapse items={teams} />{" "}
          </div>
        </>
      ) : (
        <CustomEmpty />
      )}
    </>
  );
};
